export default __webpack_public_path__ + "static/media/logo_inapp.bcb68a6b.png";